<div class="begin-umbrueckung-dialog">

  <div class="dialog-layout">
    <h2 class="dialog-h2">
      {{'swap trailer' | translate: ['tmc.begin-umbrueckung-dialog.title', translationService.language]}}
    </h2>
    <i class="horizontal-divider"></i>

    <div class="top-info">
      <app-transport-info-panel [carrier]="details.carrier" [identifier]="details.identifier" [driver]="details.name"
        [scope]="details.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content">

      <div [hidden]="currentPage !== 0">
        <h3>
          {{'target transports' | translate: ['tmc.begin-umbrueckung-dialog.table-header', translationService.language]}}
        </h3>

        <div class="table-container">
          <sc-tmc-table [tableModel]="tableModel" #tmcTableComponent></sc-tmc-table>
        </div>
      </div>

      <div [hidden]="currentPage !== 1">
        <h3>
          {{'target transport details' | translate: ['tmc.begin-umbrueckung-dialog.remaining-transport-details.title', translationService.language]}}
        </h3>

        <div>
          <mat-form-field class="width-250" [hidden]="!isTrailerNumberVisible()">
            <input name="trailerNumberPlate" matInput [(ngModel)]="details.trailerNumberPlate"
              placeholder="{{'trailer numberplate' | translate: ['tmc.begin-umbrueckung-dialog.trailerNumberPlate', translationService.language]}}"
              [required]="isTrailerNumberPlateRequired()" [maxlength]="255">
          </mat-form-field>
        </div>
        <div *ngIf="isSwapTrailerEnabled()">
          <mat-form-field class="width-250">
            <input name="swapTrailerNumber" matInput [(ngModel)]="details.swapTrailerNumber"
              placeholder="{{'swap trailer number' | translate: ['tmc.begin-umbrueckung-dialog.swapTrailerNumber', translationService.language]}}"
              [required]="isSwapTrailerNumberRequired()" [maxlength]="255">
          </mat-form-field>
        </div>

        <div class="messages">
          <app-service-response [responseMessages]="responseMessages"></app-service-response>
        </div>
      </div>

    </div>

    <i class="horizontal-divider"></i>

    <sc-actionbar>
      <button mat-stroked-button (click)="stepBack()" *ngIf="currentPage > 0"
        [matTooltip]="'back' | translate:['tmc.begin-umbrueckung-dialog.action.back', translationService.language]">
        {{'back' | translate:['tmc.begin-umbrueckung-dialog.action.back', translationService.language]}}
      </button>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button class="cancel-button" (click)="closeDialog()"
        [disabled]="isCloseDialogDisabled()">{{'cancel' | translate:['tmc.begin-umbrueckung-dialog.action.cancel', translationService.language]}}
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button class="confirm-button" mat-flat-button (click)="selectTargetTransport()"
        [disabled]="isSelectTargetTransportDisabled()" *ngIf="currentPage == 0"
        [matTooltip]="'select target transport' | translate:['tmc.begin-umbrueckung-dialog.action.select-target-transport', translationService.language]">
        {{'select target transport' | translate:['tmc.begin-umbrueckung-dialog.action.select-target-transport', translationService.language]}}
      </button>
      <button class="confirm-button" mat-flat-button (click)="beginUmbrueckung()" [disabled]="isBeginUmbrueckungDisabled()"
        *ngIf="currentPage == 1"
        [matTooltip]="'swap trailer' | translate:['tmc.begin-umbrueckung-dialog.action.begin', translationService.language]">
        {{'swap trailer' | translate:['tmc.begin-umbrueckung-dialog.action.begin', translationService.language]}}
      </button>
    </sc-actionbar>

  </div>
</div>
